import React, { useEffect, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormHelperText, FormControl, Switch, FormControlLabel } from '@material-ui/core';
import useReactHookFormStyles from '../../../../custom-components/form-components/ReactHookForm.styles';
import { generateTestId } from '../../../../../utils';

const BooleanSwitch = ({ name, reference, props: { label, defaultValue, disabled, LabelSx, values }, dynamicProps }) => {
    const classes = useReactHookFormStyles();

    const {
        watch,
        control,
        selectedValues,
        formState: { errors },
        clearErrors,
        setValue,
    } = useFormContext();
    const { referenceField, referenceKey } = reference || {};

    const watchedValues = watch(dynamicProps?.reference || []);
    const dynamicLabel = useMemo(() => {
        if (dynamicProps?.label) {
            const referenceValues = (dynamicProps?.reference || []).reduce((acc, key, index) => {
                acc[key] = watchedValues[index];
                return acc;
            }, {});
            return dynamicProps.label(referenceValues);
        }
        return label;
    }, [dynamicProps, label, ...watchedValues]);

    const truthy = values != null ? values.truthy : true;
    const falsy = values != null ? values.falsy : false;

    const mappedDefaultValue = defaultValue ? truthy : falsy;

    useEffect(
        () => {
            if (!referenceField) {
                return;
            }
            const value = selectedValues[referenceField];
            const referenceValue = value?.[referenceKey];
            clearErrors([name]);
            setValue(name, referenceValue);
        },
        !!referenceField ? [watch(referenceField)] : []
    );

    return (
        <FormControl className={classes.formController}>
            <Controller
                name={name}
                control={control}
                defaultValue={mappedDefaultValue}
                render={({ field: { onChange, value } }) => {
                    return (
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={value === truthy}
                                    disabled={disabled}
                                    onChange={() => {
                                        onChange(value === truthy ? falsy : truthy);
                                    }}
                                    data-testid={generateTestId(name, 'toggle')}
                                    // wrap
                                />
                            }
                            label={dynamicLabel}
                            labelPlacement="end"
                            sx={LabelSx}
                            // wrap
                        />
                    );
                }}
            />
            {!!errors[name] && <FormHelperText data-testid={generateTestId(name, 'toggle-error')}>{errors[name]?.message}</FormHelperText>}
        </FormControl>
    );
};

export default React.memo(BooleanSwitch);
